import * as yup from 'yup';
import { isValidYupSchema, yupUtils } from '../../utils/yup/utils';
import { LessonStats } from '../types/lessonStats';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';

const ActionCountsSchema = yup.object().shape({
  like: yupUtils.numberRequired,
  superLike: yupUtils.numberRequired,
  dislike: yupUtils.numberRequired,
  takeNote: yupUtils.numberRequired,
  addFavorite: yupUtils.numberRequired,
  completed: yupUtils.numberRequired,
  play: yupUtils.numberRequired,
  skip: yupUtils.numberRequired,
});

export const LessonStatsSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  totalScore: yupUtils.numberRequired,
  totalActionCounts: ActionCountsSchema,
  recentScore: yupUtils.numberRequired,
  recentActionCounts: ActionCountsSchema,
  title: yupUtils.stringRequired,
  pillarType: yupUtils.stringRequired,
  pillarExpertise: yupUtils.stringRequired,
  lastUpdated: yup.mixed().required(),
  searchValue: yupUtils.stringOptionalNullable,
});

const processLessonStats = async (stats: any): Promise<LessonStats> => {
  return {
    ...stats,
    lastUpdated: stats.lastUpdated ? new Date(stats.lastUpdated) : new Date(),
  };
};

export const parseLessonStats = async (object: any): Promise<LessonStats | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(LessonStatsSchema, object)) {
      return processLessonStats(object as LessonStats);
    }
    return getProjectErrorForCode(ProjectErrors.generic);
  } catch (error) {
    console.log(`[LESSON STATS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parseLessonStatsArray = async (items: any): Promise<LessonStats[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[LESSON STATS] Error: No array found.');
    return [];
  }

  const data: LessonStats[] = [];
  for (const item of items) {
    const o = await parseLessonStats(item);
    if (o && !isProjectError(o)) {
      data.push(o as LessonStats);
    }
  }

  return data;
};
